import type { ReactNode } from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';

export interface AuthCardLayoutProps {
  title?: string;
  fullHeight?: boolean;
  children: ReactNode;
}

/** Layout de tarjeta reutilizado por las 5 páginas de auth (plan.md §5.1). */
export default function AuthCardLayout({
  title,
  fullHeight = true,
  children,
}: AuthCardLayoutProps) {
  return (
    <Box
      sx={{
        minHeight: fullHeight ? '100vh' : 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: fullHeight ? 'background.default' : 'transparent',
        p: 2,
      }}
    >
      <Card sx={{ width: '100%', maxWidth: 420 }}>
        <CardContent sx={{ p: 4 }}>
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <Typography variant="h4" color="primary" fontWeight={700}>
              KIMO-Exchange
            </Typography>
            {title && (
              <Typography variant="h6" color="text.secondary" mt={1}>
                {title}
              </Typography>
            )}
          </Box>
          {children}
        </CardContent>
      </Card>
    </Box>
  );
}
